import { all } from "redux-saga/effects";
import { getConfigurationsListWatcher } from "./getConfigurationsList.saga";
import {
    getLatestSchemaWatcher,
    getProgressivesRulesWatcher
} from "./getLatestSchema.saga";
import { getConfigurationWatcher } from "./getConfiguration.saga";
import {
    createConfigurationWatcher,
    editConfigurationWatcher
} from "./createConfiguration.saga";
import { getHallBasicInfoWatcher } from "./getHallBasicInfo.saga";
import { getDenominationsWatcher } from "./getDenominations.saga";
import { getRegionsWatcher } from "./getRegions.saga";
import {
    getGameInstancesWatcher,
    getGameBundlesWatcher
} from "./getGameInstances.saga";
import {
    getDecibelsWatcher,
    getPercentagesWatcher,
    getSoundServerWatcher,
    reorderSoundsWatcher
} from "./getSoundsInfo.sage";
import { getMailingListWatcher } from "./getMailingList.saga";
import { getCurrenciesWatcher } from "./getCurrencies.saga";
import { getProductionServerWatcher } from "./getProductionServer.saga";
import { getMegapotServerListWatcher } from "./getmegapotServer.saga";
import { getMegapotProvidersListWatcher } from "./getmegapotProviders.saga";
import {
    getRTPProfilesWatcher,
    reorderRTPProfilesWatcher
} from "./getRTPProfiles.saga";

export default function* rootSaga() {
    yield all([
        getConfigurationsListWatcher(),
        getLatestSchemaWatcher(),
        getProgressivesRulesWatcher(),
        getConfigurationWatcher(),
        createConfigurationWatcher(),
        editConfigurationWatcher(),
        getHallBasicInfoWatcher(),
        getDenominationsWatcher(),
        getGameInstancesWatcher(),
        getDecibelsWatcher(),
        getPercentagesWatcher(),
        getSoundServerWatcher(),
        reorderSoundsWatcher(),
        getRegionsWatcher(),
        getMailingListWatcher(),
        getGameBundlesWatcher(),
        getCurrenciesWatcher(),
        getProductionServerWatcher(),
        getMegapotServerListWatcher(),
        getMegapotProvidersListWatcher(),
        getRTPProfilesWatcher(),
        reorderRTPProfilesWatcher()
    ]);
}
